/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-call */

/* eslint-disable @typescript-eslint/no-floating-promises */

import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { AuthWrapperService } from './auth-wrapper.service'
import { TelemetryService } from '../telemetry'


export const LOGIN_URL = 'auth/login'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private router: Router, private authWrapper: AuthWrapperService, private telemetry: TelemetryService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    let isAuthenticated = false
    let detail = 'no_valid_token'
    try {
      isAuthenticated = await this.authWrapper.isAuthenticated()
    } catch (checkError) {
      detail = `check_failed:${checkError?.message ?? ''}`
      // this error could happen when changing one page with an expired token
      // so this is fired before the auth.interceptor.ts
      try {
        void await this.authWrapper.refreshToken()
        isAuthenticated = await this.authWrapper.isAuthenticated()
      } catch (refreshError) {
        detail = `refresh_failed:${refreshError?.message ?? ''}`
      }
    }

    if (isAuthenticated) {
      return true
    } else {
      const sameSession = await this.authWrapper.isTheSameSession()
      this.telemetry.event('auth.logout', { reason: 'guard_unauthenticated', detail, sameSession: `${sameSession}`, route: state.url })
      this.telemetry.flush()
      this.router.navigate([LOGIN_URL])
      return false
    }
  }
}
